import { atom } from "jotai";
import { FileSnapshot } from "@/entities/DataAssociation/File.model";
import { QueryAtom } from "@/api/types/query.types";

export const labelingParamsAtom = atom<{
    selectedFileId?: string;
    selectedDraftId?: string;
}>({});

export const isReadonlyAtom = atom((get) => {
    const { selectedDraftId } = get(labelingParamsAtom);
    return !selectedDraftId;
});

export const selectedFileAtom = atom<QueryAtom<FileSnapshot>>({
    isLoading: true,
    isError: false,
    data: null,
});
